import juliusPic from "@/public/images/artists/julius.png";
import { Artist } from "@/types/types";

export const julius = {
  id: "181",
  name: "Julius",
  image: juliusPic,
  description: `Julius's vocal style combines smooth melodies with rhythmically sharp rap. His singing has a soft, reflective tone that feels both charming and refined. When he raps, his flow is confident and conversational, with crisp enunciation and dynamic shifts that keep the delivery fluid and engaging.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjulius-preview.mp3",
  meta: {
    free: true,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["RnB", "Hip Hop", "Pop", "Dance", "Unprocessed", "Deep"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Mid",
      },
      specific: {
        low: 46,
        high: 64,
      },
      sweetSpot: 53,
    },
  },
} as const satisfies Artist;
